import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styled from 'styled-components';
import { rem } from 'polished';
import { Text } from '../Text/index';

interface IWidgetTitle {
  children: any;
  className?: string;
  icon: IconProp;
  type?: string;
}

const StyledWidgetTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${({ theme }) => theme.rhythmSizing(3)}rem;
  color: ${({ theme }) => theme.colors.white_1_90};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .widgetTitle__icon {
    font-size: ${rem(`36px`)};
    path {
      fill: url('#rainbow_1_svg') #fff;
    }
    margin: 0 ${rem(`8px`)};
  }
`;

export const WidgetTitle = ({
  children,
  className,
  icon,
  type = `title3`,
}: IWidgetTitle) => (
  <StyledWidgetTitle className={className}>
    <FontAwesomeIcon className="widgetTitle__icon" icon={icon} />
    <Text noRhythem type={type} tag="span">
      {children}
    </Text>
  </StyledWidgetTitle>
);
